<template>
  <header role="group" :class="[
    `align-${align}`,
    {
      'page-hina': isHina,
    }
  ]">
    <h1 class="jps-lh-title">
      <BaseIcon v-if="icon" :name="icon" size="size-full" class="jps-icon" />
      <span class="jps-lh-title-span">{{ ls(title) }}</span>
    </h1>
    <p class="jps-lh-description">
      {{ ls(description) }}
    </p>
  </header>
</template>

<script lang="ts" setup>
import type { SVG_NAMES } from '~/components/icons'

interface Props {
  title: LangString
  description?: LangString
  icon?: SVG_NAMES
  align?: 'left' | 'center'
}

withDefaults(defineProps<Props>(), {
  align: 'left'
})

const { ls } = useI18n()
const { isHina } = useServiceType()
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-lh-title {
  display: flex;
  align-items: center;
  word-break: break-word;
  font-weight: 600;
  line-height: 1.125;
  margin-bottom: 0.75rem;

  @include is-mobile {
    margin-bottom: 0.5rem;
  }

  .jps-lh-title-span {
    font-size: $size-4;
    @include is-mobile {
      font-size: $size-6;
    }
  }

  .jps-icon {
    margin-right: 1rem;
    max-width: $size-3;
    max-height: $size-3;
    display: block;
    @include is-mobile {
      max-width: $size-5;
      max-height: $size-5;
    }
  }
}
.jps-lh-description {
  font-size: $size-6;
  @include is-mobile {
    font-size: $size-7;
  }
}

.align-left {
  .jps-lh-description {
    padding-left: 3rem;
    @include is-mobile {
      padding-left: 0;
    }
  }
}

.align-center {
  .jps-lh-title {
    justify-content: center;
  }

  .jps-lh-description {
    text-align: center;
  }
}


.page-hina {
  .jps-lh-title-span {
    font-size: $size-3;
    font-weight: normal;
    @include is-mobile {
      font-size: $size-5;
    }
  }

  .jps-lh-description {
    color: $jps-gray-700;
    font-size: $size-7;
  }
}
</style>
